import React = require("react");
import { DefaultOverview, DefaultTopics } from "./DefaultViews";

export const CommonConfigurationTestPermissionOverview: React.StatelessComponent<{}> = props => {
    return <DefaultOverview />;
};

export const CommonConfigurationTestPermissionTopics: React.StatelessComponent<{}> = props => {
    return <DefaultTopics />;
};